<div class="search-container">

    <i class="fa fa-search search-icon"></i>
    <input  class="form-control form-control-sm search-box" type="text" placeholder="Find site by name or zone"
        [formControl]="findSiteInputControl" [matAutocomplete]="siteAutoComplete"> 
               <span class="deleteicon" ><i class="fas fa-times" (click)="clearInput()"></i></span>
               
    <mat-autocomplete #siteAutoComplete [displayWith]="siteAutoComplete_displayFn"
        (optionSelected)="siteAutoComplete_optionSelected($event)">
        <mat-option class="search-container-mat-option"
            *ngFor="let option of findSiteInputControl_filteredOptions | async" [value]="option">
            <span>{{option.name}}</span> 
            <small>| Power: {{option.info?.power | watts:1000000}}</small>
            <small>| {{option.info?.zone}}</small>
        </mat-option>
    </mat-autocomplete>

</div>
